import React, { useEffect, useState } from "react";
import Question from "./Question";
import Answer from "./Answer";
import editIcon from "../../assets/icons8-edit.svg";
import "./QuestionAnswer.css";
import "./Answer.css";
import "normalize.css";
import kyraImage from "../../assets/kface1.png";


export default function QuestionAnswer(props) {
  const {
    questionObject,
    answerSelectionCallback,
    startSurvey,
    predfinedQuestionsForComment,
    onEditClick,
    userInput,
    editIsOn,
    editedQuestionId,
    setEditedQuestionId,
    showMessageList,
    setShowMessagesList,
    customLTypeQuestion,
    chroImage,
  } = props;
  const [isEdit, setIsEdit] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const regex = /\b.*comment/;

  useEffect(() => {
    setShowAnswer(false);
    const timeout = setTimeout(() => {
      setShowAnswer(true);
    }, 900);

    return () => {
      clearTimeout(timeout);
    };
  }, [questionObject?.qid, customLTypeQuestion]);

  function answerCallBack(ans, qid, gid, type) {
    answerSelectionCallback(ans, qid, gid, type, isEdit);
    setIsEdit(false);
    setEditedQuestionId(0);
  }

  function DetectGivenAnswer(question) {
    const isEditingThis =
      editIsOn &&
      editedQuestionId?.qid != null &&
      String(question?.qid) === String(editedQuestionId?.qid);

    if (
      question?.givenAnswer?.skipped &&
      !isEditingThis &&
      (question?.type === "T" || question?.type === "comment")
    ) {
      return (
        <div className="answer-wrapper">
          <div className="mine replyMessages">
            <div className="replyMessagesAnsweres last skipped-answer-label text-base mobile:text-xs font-medium py-4 px-6 mobile:py-3.5 mobile:px-4">
              Skipped
            </div>
          </div>
          <img
            alt="edit"
            onClick={() => {
              onEditClick(questionObject?.qid, true, questionObject?.gid);
            }}
            className="editIcon"
            src={editIcon}
          />
        </div>
      );
    }

    if (
      !question?.type &&
      question?.answers?.length > 0 &&
      !startSurvey &&
      !startSurvey?.isSurveyStart &&
      question?.givenAnswer?.answer
    ) {
      return (
        <Answer
          showAnswer={showAnswer}
          isComment={true}
          onAnswerClick={answerSelectionCallback}
          answer={question?.givenAnswer}
          isSubmit={!!question?.isSubmit}
        />
      );
    }

    if (
      !question?.type &&
      question?.answers?.length > 0 &&
      !startSurvey?.isSurveyStart
    ) {
      return (
        <Answer
          showAnswer={showAnswer}
          isStart={true}
          onAnswerClick={answerSelectionCallback}
          answer={question?.answers}
          qid={question?.qid}
          gid={question?.gid}
          isSubmit={!!question?.isSubmit}
        />
      );
    }

    if (
      !question?.type &&
      question?.answers?.length > 0 &&
      startSurvey?.isSurveyStart
    ) {
      return (
        <Answer
          showAnswer={showAnswer}
          isComment={true}
          onAnswerClick={answerSelectionCallback}
          answer={startSurvey}
          isSubmit={!!question?.isSubmit}
        />
      );
    }

    if (
      !question?.type &&
      question?.answers?.length > 0 &&
      userInput !== null
    ) {
      return (
        <Answer
          showAnswer={showAnswer}
          isComment={true}
          answer={{ comment: userInput }}
          isSubmit={!!question?.isSubmit}
        ></Answer>
      );
    }

    if (
      question?.type === "T" &&
      question?.givenAnswer &&
      question?.givenAnswer?.answer_code === null
    ) {
      return (
        <>
          {question?.givenAnswer?.comment &&
          question?.givenAnswer?.comment !== null ? (
            <div className="answer-wrapper">
              {" "}
              <Answer
                showAnswer={showAnswer}
                type={question?.type}
                qid={question?.qid}
                gid={question?.gid}
                answer={question?.givenAnswer}
                isComment={true}
                isSubmit={!!question?.isSubmit}
              />
              <img
                alt="edit"
                onClick={() => {
                  onEditClick(questionObject?.qid, true, questionObject?.gid);
                }}
                className="editIcon"
                src={editIcon}
              ></img>
            </div>
          ) : null}
        </>
      );
    }

    if (!question?.type) {
      return null;
    }

    if (
      (question?.type === "L" &&
        question?.givenAnswer &&
        question?.givenAnswer?.answer_code === null) ||
      (question.type === "L" &&
        question?.qid &&
        question?.qid === editedQuestionId?.qid)
    ) {
      return (
        <>
          {" "}
          <Answer
            showAnswer={showAnswer}
            customLTypeQuestion={customLTypeQuestion}
            type={question?.type}
            isStart={question?.type === "O" ? true : false}
            qid={question?.qid}
            gid={question?.gid}
            onAnswerClick={answerCallBack}
            answer={question?.answer}
            initialLikertAnswerCode={question?.givenAnswer?.answer_code}
            onTenPointSliderCancel={
              question?.type === "L" &&
              question?.givenAnswer != null &&
              question?.givenAnswer?.answer_code != null &&
              question?.qid === editedQuestionId?.qid
                ? () => setEditedQuestionId(0)
                : undefined
            }
            isSubmit={!!question?.isSubmit}
          />{" "}
        </>
      );
    }

    if (
      question.type === "O" &&
      question?.qid &&
      question?.qid === editedQuestionId?.qid
    ) {
      return (
        <>
          {" "}
          <Answer
            showAnswer={showAnswer}
            customLTypeQuestion={customLTypeQuestion}
            type={question?.type}
            isStart={question?.type === "O" ? true : false}
            qid={question?.qid}
            gid={question?.gid}
            onAnswerClick={answerCallBack}
            answer={question?.answer}
            initialLikertAnswerCode={question?.givenAnswer?.answer_code}
            onTenPointSliderCancel={
              question?.type === "L" &&
              question?.givenAnswer != null &&
              question?.givenAnswer?.answer_code != null &&
              question?.qid === editedQuestionId?.qid
                ? () => setEditedQuestionId(0)
                : undefined
            }
            isSubmit={!!question?.isSubmit}
          />{" "}
        </>
      );
    }

    if (
      (question?.type === "L" &&
        question?.givenAnswer &&
        question?.givenAnswer?.answer_code !== null) ||
      (question?.type === "L" &&
        question?.qid &&
        question?.qid === editedQuestionId?.qid)
    ) {
      return (
        <div className="answer-wrapper">
          {" "}
          <Answer
            showAnswer={showAnswer}
            customLTypeQuestion={customLTypeQuestion}
            answer={question?.givenAnswer}
            likertOptionCount={
              question?.type === "L" && Array.isArray(question?.answer)
                ? question.answer.length
                : undefined
            }
            type={question?.type}
            qid={question?.qid}
            gid={question?.gid}
            isSubmit={!!question?.isSubmit}
          ></Answer>{" "}
          <img
            alt="edit"
            onClick={() => {
              onEditClick(questionObject?.qid, false, questionObject?.gid);
            }}
            className="editIcon"
            src={editIcon}
          ></img>{" "}
        </div>
      );
    }

    if (
      question?.type !== "L" &&
      question?.givenAnswer &&
      question?.givenAnswer?.answer_code === null &&
      !question?.givenAnswer?.skipped
    ) {
      return (
        <>
          {question?.givenAnswer?.comment !== null ? (
            <>
              {" "}
              <Answer
                showAnswer={showAnswer}
                type={question?.type}
                qid={question?.qid}
                gid={question?.gid}
                answer={question?.givenAnswer}
                isComment={true}
                isSubmit={!!question?.isSubmit}
              ></Answer>
            </>
          ) : null}
          {question?.givenAnswer?.answer_code === null ? (
            <>
              {" "}
              <Answer
                showAnswer={showAnswer}
                isStart={true}
                onAnswerClick={answerCallBack}
                type={question?.type}
                qid={question?.qid}
                gid={question?.gid}
                answer={question?.answer}
                isSubmit={!!question?.isSubmit}
              ></Answer>
            </>
          ) : null}
        </>
      );
    }

    if (
      question?.type !== "L" &&
      question?.givenAnswer &&
      question?.givenAnswer?.answer_code !== null
    ) {
      return (
        <>
          {question?.givenAnswer?.answer_code ? (
            <div className="answer-wrapper">
              {" "}
              <Answer
                isStart={true}
                showAnswer={showAnswer}
                onAnswerClick={answerCallBack}
                type={question?.type}
                qid={question?.qid}
                gid={question?.gid}
                answer={question?.givenAnswer}
                isSubmit={!!question?.isSubmit}
              />{" "}
              <img
                alt="edit"
                onClick={() => {
                  onEditClick(
                    questionObject?.qid,
                    question?.givenAnswer?.comment !== null ? true : false,
                    questionObject?.gid
                  );
                }}
                className="editIcon"
                src={editIcon}
              ></img>{" "}
            </div>
          ) : question?.givenAnswer?.comment !== null ? (
            <div className="answer-wrapper">
              {" "}
              <Answer
                showAnswer={showAnswer}
                type={question?.type}
                qid={question?.qid}
                gid={question?.gid}
                answer={question?.givenAnswer}
                isComment={true}
                isSubmit={!!question?.isSubmit}
              />{" "}
              <img
                alt="edit"
                onClick={() => {
                  onEditClick(
                    questionObject?.qid,
                    question?.givenAnswer?.comment !== null ? true : false,
                    questionObject?.gid
                  );
                }}
                className="editIcon"
                src={editIcon}
              ></img>{" "}
            </div>
          ) : null}
        </>
      );
    }
  }

  if (questionObject?.qid === "NOT_NOW_RESPONSE") {
    return (
      <div className="flex flex-col mb-4" id="question-NOT_NOW_RESPONSE">
        <Question
          imageSrc={chroImage ? chroImage : kyraImage}
          question={questionObject?.question}
        />
        <div className="questionAnswer">
          {showAnswer ? (
            <div className="startSurveyContainer">
              <button
                type="button"
                className="startBtn mobile:text-xs mobile:py-2 mobile:px-4 text-base px-4 py-3"
                onClick={() => window.location.reload()}
              >
                Re-start
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col mb-4" id={`question-${questionObject?.qid}`}>
      <Question imageSrc = {chroImage ? chroImage : kyraImage}  question={questionObject?.question} />
      {regex.test(questionObject?.qid) ? (
        <Question imageSrc = {chroImage ? chroImage : kyraImage} question={predfinedQuestionsForComment?.question}></Question>
      ) : null}
      <div key={questionObject?.qid} className="questionAnswer">
        {showAnswer && DetectGivenAnswer(questionObject)}
      </div>
    </div>
  );
}
